var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckboxInverti = function SvgCheckboxInverti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 3.7h14c.7 0 1.3.6 1.3 1.3v14c0 .7-.6 1.3-1.3 1.3H5c-.7 0-1.3-.6-1.3-1.3V5c0-.7.6-1.3 1.3-1.3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "m6.7 12.4 3.2 2.9 7.4-6.7"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxInverti);
export default ForwardRef;